export default "__VITE_ASSET__DfWpd6_s__"